import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link, Redirect } from 'react-router-dom';
import Loader from '../../common/Loader';
import DetailPhoto from '../../common/DetailPhoto';
import Messages from '../../common/Messages';
import BreadcrumbMenu from '../../menu/BreadcrumbMenu';
import ImageUploadDialog from '../../common/ImageUploadDialog';
import $ from 'jquery';

import PersonaOracleForm from './PersonaOracleForm';
import PersonaOraclePhonesTable from './PersonaOraclePhonesTable';
import PersonaOraclePagesTable from './PersonaOraclePagesTable';

import {
  GET_PERSONA_ORACLE,
  UPDATE_PERSONA_ORACLE,
  CREATE_PERSONA_ORACLE,
  UPLOAD_ORACLE_AVATAR
} from '../../../constants/actionTypes';

class PersonaOracleDetailView extends React.PureComponent {

  componentDidMount() {
    if (this.props.match.params.mode !== 'new') {
      this.props.getPersonaOracle({id: this.props.match.params.id});
    }
  }

  render() {
    const mode = this.props.match.params.mode;

    if (this.props.loading)
      return (
        <main id="user" className="col-sm-12 col-lg-9">
          <div><Loader loading={this.props.loading}/></div>
        </main>
      );

    if (this.props.redirectToList)
      return (<Redirect to='/personas' />);

    const breadcrumbs = [
      {
        title: "Správa kartářek",
        to: '/personas'
      },
      {
        title: mode !== 'new' ? this.props.oracleDetail.name : 'Nová kartářka',
        active: true,
        label: mode !== 'new' ? this.props.oracleDetail.title : null
      }
    ];

    return (
      <React.Fragment>
        <main id="user" className="col-sm-12 col-lg-9">
          <Messages/>
          <div>
            <div className="clearfix">
              <BreadcrumbMenu crumbs={breadcrumbs}/>
              {mode !== 'new' &&
                <div className="float-right">
                  <div className="dropdown">
                    <button className="btn" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <img src="/img/cog.png" alt="Možnosti" title="Možnosti"/>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
                      {
                        mode === 'detail' ? <Link className="dropdown-item" to={'/personas/oracle/' + this.props.oracleDetail.oracleId + '/edit'}>Upravit údaje</Link> :
                          <Link className="dropdown-item" to={'/personas/oracle/' + this.props.oracleDetail.oracleId + '/detail'}>Zpět na detail</Link>
                      }
                      <Link className="dropdown-item" to="/" data-toggle="modal" data-target="#imageUploadDialog">Změnit fotku</Link>
                      <div className="dropdown-divider"></div>
                      <Link className="dropdown-item" to={'/personas/oracle/' + this.props.oracleDetail.oracleId + '/addnum'}>Přidat tel. číslo</Link>
                      <div className="dropdown-divider"></div>
                      <Link className="dropdown-item" to="/">Smazat kartářku</Link>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div className="row">
              <div className="col-12 col-md-4">
                <DetailPhoto src={'/api/adm/persona/oracle/' + this.props.oracleDetail.oracleId + '/avatar'}
                   xt={this.props.avatarPhotoUpdateDate}
                   alt={mode !== 'new' ? this.props.oracleDetail.name : 'Nová kartářka'}
                   loading={this.props.uploadingAvatarPhoto}
                   defaultSrc="/img/user-w.png" mode={mode}/>
              </div>
              <div className="col-12 col-md-8">
                <PersonaOracleForm mode={mode} readOnly={mode === 'detail'} onSubmit={mode === 'edit' ? this.handleOracleUpdate : this.handleOracleCreate}/>
              </div>
            </div>

            { mode === 'detail' && this.props.oracleDetail.oracleAssignments
              && <PersonaOraclePagesTable pages={this.props.oracleDetail.oracleAssignments} /> }
            { mode === 'detail' && this.props.oracleDetail.phoneNumbers
              && <PersonaOraclePhonesTable phoneNumbers={this.props.oracleDetail.phoneNumbers} /> }
          </div>
        </main>
        <ImageUploadDialog id="imageUploadDialog" title="Změna fotky kartářky"
          handleImageSubmit={this.handleImageSubmit}
          previewWidth={'250px'} previewHeight={'300px'}
          maxFileSize={10 * 1024 * 1024}/>
      </React.Fragment>
    );
  }

  handleImageSubmit = image => {
    this.props.uploadOracleAvatar({
      oracleId: this.props.oracleDetail.oracleId,
      file: image
    });
    $("#imageUploadDialog").modal("hide");
  }

  handleOracleUpdate = values => {
    values['oracleId'] = this.props.oracleDetail.oracleId;
    this.props.updatePersonaOracle(values);
  }

  handleOracleCreate = values => {
    values['userId'] = this.props.match.params.id;
    this.props.createPersonaOracle(values);
  }
}

const mapStateToProps = state => {
  return {
    loading: state.persona.loading,
    oracleDetail: state.persona.oracleDetail,
    error: state.persona.error,
    errorDetail: state.persona.errorDetail,
    redirectToList: state.persona.redirectToList,
    avatarPhotoUpdateDate: state.persona.avatarPhotoUpdateDate,
    uploadingAvatarPhoto: state.persona.uploadingAvatarPhoto
  }
};

const mapDispatchToProps = dispatch => ({
  getPersonaOracle: payload =>
    dispatch({ type: GET_PERSONA_ORACLE, payload }),
  updatePersonaOracle: payload =>
    dispatch({ type: UPDATE_PERSONA_ORACLE, payload }),
  createPersonaOracle: payload =>
    dispatch({ type: CREATE_PERSONA_ORACLE, payload }),
  uploadOracleAvatar: payload =>
    dispatch({ type: UPLOAD_ORACLE_AVATAR, payload })
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PersonaOracleDetailView));
